module.exports = __webpack_public_path__ + "static/img/join_11.91651c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join_11.png
// module id = rzss
// module chunks = 0